import { render, staticRenderFns } from "./project-step-notes.vue?vue&type=template&id=2f26d11b&"
import script from "./project-step-notes.vue?vue&type=script&lang=js&"
export * from "./project-step-notes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports